import React from 'react';
import Home from '../Home'
import styles from './App.module.scss'

const App = () => (
  <div className={styles.container}>
    <Home />
  </div>
)

export default App;
